import styled from 'styled-components'

import CBoxedContent from '../../components/BoxedContent'
import CHtml from '../../components/Html'
import MediaComponent from '../../components/MediaComponent'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.aliceBlue};
`

export const BoxedContent = styled(CBoxedContent)`
  padding: 0 1.6rem;
`

export const HTML = styled(CHtml)`
  padding: 6rem 0;
`

export const BottomMediaComponent = styled(MediaComponent)`
  padding-bottom: 6rem;
`
